import React, { useMemo } from 'react';
import deepmerge from 'deepmerge';
import { MgpGaugeChartContainer, MgpGaugeChartLabel } from './MgpGaugeChartStyles';
import Chart from '../../../CommonComponents/Chart';
import {
  MGP_GAUGE_CHART_BASE_CONFIG,
  MGP_GAUGE_CHART_SERIES_OPTIONS,
} from './MgpGaugeChartConstants';
import { Box } from '../../../CommonComponents/OPL/Box/Box';

export type ChartZone = {
  range: [number, number];
  color: string;
};

export type TargetZone = {
  color: string;
  status: string;
};

export interface MgpGaugeChartData {
  value: number;
  targetZone: TargetZone;
  zones: ChartZone[];
}

interface Props {
  data?: MgpGaugeChartData | null;
}

export const MgpGaugeChart: React.FC<Props> = ({ data }) => {
  const options = useMemo(
    () =>
      deepmerge(MGP_GAUGE_CHART_BASE_CONFIG, {
        series: [
          {
            ...MGP_GAUGE_CHART_SERIES_OPTIONS,
            data: data ? [data.value] : [0],
          },
        ],
        yAxis: {
          plotBands: data
            ? data.zones.map(({ range, color }) => ({
                from: range[0],
                to: range[1],
                color,
                innerRadius: '60%',
              }))
            : null,
        },
      }),
    [data],
  );

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <MgpGaugeChartContainer>
        <Chart options={options} />
      </MgpGaugeChartContainer>
      {data?.targetZone && (
        <MgpGaugeChartLabel color={data.targetZone.color}>
          {data.targetZone.status}
        </MgpGaugeChartLabel>
      )}
    </Box>
  );
};
